import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { withTheme } from 'styled-components';
import 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up'; // Transparent pixel png

var IMAGE_FALLBACK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var Wrapper = styled.div.withConfig({
  displayName: "Picture__Wrapper",
  componentId: "sc-1x3z81z-0"
})(["position:relative;display:block;width:", ";height:", ";"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.height ? props.height : '100%';
});
var Image = styled.img.withConfig({
  displayName: "Picture__Image",
  componentId: "sc-1x3z81z-1"
})(["display:block;width:", ";height:", ";object-fit:", ";"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.height ? props.height : 'auto';
}, function (props) {
  return props.objectFit === 'none' && 'none' || props.objectFit === 'cover' && 'cover' || props.objectFit === 'contain' && 'contain';
});
/** Responsive Picture */

var Picture = function Picture(_ref) {
  var images = _ref.images,
      image = _ref.image,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      objectFit = _ref.objectFit,
      imageLow = _ref.imageLow,
      rest = _objectWithoutProperties(_ref, ["images", "image", "alt", "width", "height", "objectFit", "imageLow"]);

  if (!images) {
    return React.createElement(Wrapper, Object.assign({
      height: height,
      width: width
    }, rest), React.createElement(Image, {
      alt: alt,
      height: height,
      width: width,
      objectFit: objectFit,
      "data-src": image,
      className: "lazyload"
    }));
  }

  return React.createElement(Wrapper, Object.assign({
    height: height,
    width: width
  }, rest), React.createElement(Image, {
    alt: alt,
    height: height,
    width: width,
    objectFit: objectFit,
    src: image,
    srcSet: IMAGE_FALLBACK,
    "data-src": image,
    "data-srcset": images,
    "data-sizes": "auto",
    "data-lowsrc": imageLow,
    className: "lazyload"
  }));
};

Picture.defaultProps = {
  imageLow: null,
  image: null,
  images: null,
  objectFit: 'none',
  width: '100%',
  height: 'auto',
  alt: ''
};
export default withTheme(Picture);